import { Models } from '$models';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { map } from 'rxjs';
import { SettingsService } from '../../shared/stores';

@Component({
  selector: 'app-mobile-navigation',
  templateUrl: './mobile-navigation.component.html',
  styleUrls: ['./mobile-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [RouterLink, FontAwesomeModule, AsyncPipe],
})
export class MobileNavigationComponent {
  private settings = inject(SettingsService);
  searchRouteSlug = Models.SearchRouteSlug;
  buySellTitle$ = this.settings.user$.pipe(map(data => (data?.UserType === 'Client' ? 'Client Portal' : 'Buy / Sell')));
}
